export const MapPage = () => import(/* webpackChunkName: "map-page" */ "./pages/map-page");
